import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk, RootState } from "./store";
import { getOrgId } from "./orgHelpers";
import { ReceiptsService } from "../services/ReceiptsService";
import { ItemListResponse, LatestResponse } from "../models/Receipts";

interface ReceiptsState {
  latestTransactions: LatestResponse | null,
  latestPurchases: LatestResponse | null,
  latestPayments: LatestResponse | null,
  latestInvoices: LatestResponse | null,
  latestDeposits: LatestResponse | null,
  latestShipments: LatestResponse | null,
  listOrders: LatestResponse | null,
  listReceipts: LatestResponse | null,
  fileStatus: boolean
}

const initialState: ReceiptsState = {
  latestTransactions: null,
  latestPurchases: null,
  latestPayments: null,
  latestInvoices: null,
  latestDeposits: null,
  latestShipments: null,
  listOrders: null,
  listReceipts: null,
  fileStatus: false
};

const receiptsSlice = createSlice({
    name: 'receipts',
    initialState,
    reducers: {
        setLastestTransactions: (state, action :PayloadAction<LatestResponse>) => {
          console.log(action.payload);
          state.latestTransactions = action.payload;
        },
        setLastestPurchases: (state, action :PayloadAction<LatestResponse>) => {
          state.latestPurchases = action.payload;
        },
        setLastestPayments: (state, action :PayloadAction<LatestResponse>) => {
          state.latestPayments = action.payload;
        },
        setLastestInvoices: (state, action :PayloadAction<LatestResponse>) => {
          state.latestInvoices = action.payload;
        },
        setLastestDeposits: (state, action :PayloadAction<LatestResponse>) => {
          state.latestDeposits = action.payload;
        },
        setLastestShipments: (state, action :PayloadAction<LatestResponse>) => {
          state.latestShipments = action.payload;
        },
        setFileStatus: (state, action :PayloadAction<boolean>) => {
          state.fileStatus = action.payload;
        },
        setOrders: (state, action :PayloadAction<LatestResponse>) => {
          state.listOrders = action.payload;
        },
        setReceipts: (state, action :PayloadAction<LatestResponse>) => {
          state.listReceipts = action.payload;
        },
    }
  });
  
export const {
  setLastestTransactions,
  setLastestPurchases,
  setLastestPayments,
  setLastestInvoices,
  setLastestDeposits,
  setLastestShipments,
  setFileStatus,
  setOrders
} = receiptsSlice.actions;

// customs func
export const fetchLatest = (entity:string, page:number = 1) : AppThunk<Promise<void>> => async (dispatch, getState) => {

  const state = getState();
  const id = getOrgId(state);

  try {
    
    const response : LatestResponse = await ReceiptsService.getLatest(id, entity, page);
    if(!response) throw new Error('Erro ao buscar as ultimas entradas')
  
    const currentState = getState();

    const merge = (current: LatestResponse | null) : LatestResponse => {
      if (page > 1 && current) {
        const newResponse = { ...response, data: [...current.data, ...response.data] };
        return newResponse;
      }
      return response;
    }

    if (entity === 'all')       dispatch (setLastestTransactions(merge(currentState.receipts.latestTransactions)))
    if (entity === 'purchases') dispatch (setLastestPurchases(merge(currentState.receipts.latestPurchases)))
    if (entity === 'invoices')  dispatch (setLastestInvoices(merge(currentState.receipts.latestInvoices)))
    if (entity === 'payments')  dispatch (setLastestPayments(merge(currentState.receipts.latestPayments)))
    if (entity === 'deposits')  dispatch (setLastestDeposits(merge(currentState.receipts.latestDeposits)))
    if (entity === 'shipments') dispatch (setLastestShipments(merge(currentState.receipts.latestShipments)))

  } catch (e) {
    console.error(e);
  }

}

export default receiptsSlice.reducer;

export const sendOrderFile = ( formData: FormData ): AppThunk<Promise<void>> => async (dispatch, getState) => {
  dispatch(setFileStatus(true));
  const state = getState();
  try {
    const user_id = state.user.userInfo.id;
    const organization_id = getOrgId(state);
    const payload = {
      formData,
      user_id,
      organization_id
    }
    const savedOrder = await ReceiptsService.sendOrder(payload);
    if (savedOrder) throw new Error('erro ao tentar salvar a ordem. '+savedOrder)
    dispatch( fetchOrders(organization_id) )
  } catch (e) {
    console.error(e);
  } finally {
    dispatch(setFileStatus(false));
  }
}

export const fetchOrders = (id:number): AppThunk<Promise<void>> => async (dispatch, getState) => {
  try {
    const listOrder = await ReceiptsService.getOrders(id);
    if (!listOrder) throw new Error('erro ao tentar salvar a ordem. '+listOrder)
    dispatch( setOrders(listOrder) )
  } catch (e) {
    console.error(e);
  } 
}